import type { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-md border border-dashed border-muted/40 bg-surface p-8 text-center",
        className,
      )}
      {...props}
    >
      {icon && <div className="text-accent">{icon}</div>}
      <div className="text-base font-semibold">{title}</div>
      {description && <div className="max-w-prose text-sm text-muted">{description}</div>}
      {action}
    </div>
  );
}

export default EmptyState;
